module.exports = __webpack_public_path__ + "application/templates/default/inner/module-financial/module-financial.template.html";